import "./assets/css/App.css"
import "./assets/css/Loading.css"
import "./assets/css/date_picker.css"
import "./assets/css/droppable.css"
import "./assets/css/react_selector.css"
import "./assets/css/text.css"
import "./assets/scss/index.scss"
import { Navigate, Route, Routes } from "react-router-dom";
import Router from "./routes";
import { Tokens } from "./constant";
import YCR from "./pages/dashboard/admin/ycr/YCR";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/register";
import AdminCurves from "./pages/dashboard/admin/curves"
import ResetPassword from "./pages/auth/ResetPassword";
import VerifyEmail from "./pages/auth/VerifyEmail";


const App = () => {
  const token = localStorage.getItem(Tokens.ADMIN_TOKEN)
  const user = localStorage.getItem(Tokens.ADMIN_ROLE)
  return (
    <>
      <Routes>
        <Route path='/login' element={token ? user === 'admin' ? <Navigate replace to={'/admin/ycr'} /> : <Navigate replace to={'/'} /> : <Login />} /> 
        <Route path='/register' element={token ? <Navigate replace to={'/'} /> : <Register />} />
        <Route path='/reset-password' element={token !== null ? <Navigate replace to={'/'} /> : <ResetPassword />} />
        <Route path='/verify-email' element={token !== null ? <Navigate replace to={'/signup'} /> : <VerifyEmail />} />
        <Route path='/forgot-password' element={token ? <Navigate replace to={'/'} /> : <Register />} />
        {user === 'user' ? <Route path='/' element={token ? <Navigate replace to={'/curves'} /> : <Navigate replace to={'/login'} />} /> :
          <Route path='/admin/ycr' element={token ? <YCR /> : <Navigate replace to={'/login'} />} />}
        <Route path='/curves' element={token ? <AdminCurves /> : <Navigate replace to={'/login'} />} />
        {/* <--- routes making --->*/}
        <Route path='/*' element={<Router />} />
        <Route path='*' element={<Navigate replace to={"/"} />} />
      </Routes>
    </>
  );
}

export default App;
